import { render, staticRenderFns } from "./bayit.20210203.default.vue?vue&type=template&id=5b8959ca&slot=start-instructions&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports